// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ka-0";
export var fileCarousel = "_ka-2";
export var removeFileButton = "_ka-1";